<div
	class="bg-[#FCFCFC] lg:p-[46px] p-[26px] max-w-[981px] m-auto custom-shadow rounded-12px"
>
	<div class="text-center mb-[36px]">
		<p class="text-medium-gray text-[12px]">
			{{ 'PRODUCT_PROMO.PRODUCT_PROMO' | translate }}
		</p>
		<p class="text-[#4E4B66] font-semibold leading-[26px] text-[24px]">
			{{ 'PRODUCT_PROMO.ADD_NEW_PROMO_CODE' | translate }}
		</p>
	</div>

	<div class="flex flex-col" [formGroup]="productPromoCodeForm">
		<!-- Activation State Start -->

		<div class="w-full h-[98px] rounded-[12px] bg-main-color-black">
			<div
				class="flex justify-between px-[24px] py-[28px] max-mobile:px-padding-mobile-14 max-mobile:py-padding-mobile-14"
			>
				<div class="flex flex-col my-auto max-mobile:text-font-mobile-small">
					<p class="text-gradient mb-1">
						{{ 'GENERAL_LABELS.STATUS' | translate }}
					</p>
					<p class="text-[#F5F5F5] mb-1 max-mobile:text-font-mobile-small">
						{{ 'PRODUCT_PROMO.ABILITY_TO' | translate }}
					</p>
				</div>

				<div class="flex">
					<ng-container *ngFor="let val of isActiveEnum">
						<span
							*ngIf="getController('isActive')?.value == val?.value"
							class="{{
								getController('isActive')?.value
									? ' text-[#00BA88] '
									: '  text-[#B3261E]  '
							}}mx-auto lg:mt-3 mt-5"
							>{{ 'STATUS.' + val.name.toUpperCase() | translate }}</span
						>
					</ng-container>
					<div class="lg:w-[36px] m-auto mx-2">
						<mat-slide-toggle
							formControlName="isActive"
							hideIcon
						></mat-slide-toggle>
					</div>
				</div>
			</div>
		</div>

		<div class="mt-36px">
			<div class="py-[14px]">
				<p class="mb-0 font-DIN-Medium text-font-16">
					{{ 'PRODUCT_PROMO.BASIC_INFO' | translate }}
				</p>
			</div>
			<div class="bg-off-white rounded-12px p-24px shadow">
				<!-- NAME EN AR -->
				<div class="flex justify-between items-start">
					<mat-form-field class="w-[49%] relative" appearance="outline">
						<mat-label class="text-dark-grey"
							>{{ 'PRODUCT_PROMO.NAME_EN' | translate }}
						</mat-label>
						<input
							formControlName="offerNameEn"
							class="text-font-16 text-[#4E4B66] w-[93%]"
							type="text"
							matInput
							placeholder="{{ 'PRODUCT_PROMO.NAME_EN' | translate }}"
						/>
						<img
							*ngIf="getController('offerNameEn')?.value"
							(click)="getController('offerNameEn')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('offerNameEn')"
								controller_name="PRODUCT_PROMO.NAME_EN"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
					<mat-form-field class="w-[49%] relative" appearance="outline">
						<mat-label class="text-dark-grey">{{
							'PRODUCT_PROMO.NAME_AR' | translate
						}}</mat-label>
						<input
							required
							formControlName="offerNameAr"
							class="text-font-16 text-[#4E4B66] w-[93%]"
							type="text"
							matInput
							placeholder="{{ 'PRODUCT_PROMO.NAME_AR' | translate }}"
						/>
						<img
							*ngIf="getController('offerNameAr')?.value"
							(click)="getController('offerNameAr')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('offerNameAr')"
								controller_name="PRODUCT_PROMO.NAME_AR"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
				</div>
				<!-- NAME EN AR -->
				<!-- promo code  name -->

				<mat-form-field class="w-full relative" appearance="outline">
					<mat-label class="text-dark-grey">{{
						'PRODUCT_PROMO.PROMO_CODE' | translate
					}}</mat-label>
					<input
						(keyup)="checkUnique($event)"
						required="true"
						formControlName="code"
						type="text"
						class="text-font-16 text-[#4E4B66] w-[95%]"
						placeholder="{{ 'PRODUCT_PROMO.PROMO_CODE' | translate }}"
						matInput
					/>
					<img
						*ngIf="getController('code')?.value"
						(click)="getController('code')?.reset()"
						class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
						src="./assets/images/close-square.svg"
						alt=""
					/>
					<mat-error>
						<validation-message
							[controller]="getController('code')"
							controller_name="PRODUCT_PROMO.PROMO_CODE"
						>
						</validation-message>
						<mat-error *ngIf="productPromoCodeForm.get('code')?.errors?.unique">
							<span class="text-red-error text-font-12">{{
								'VALIDATION.CODE_UNIQUE' | translate
							}}</span>
						</mat-error>
					</mat-error>
				</mat-form-field>
				<!-- promo code  name -->

				<!-- UPLOAD IMAGE  -->
				<div
					class="flex flex-wrap lg:justify-between w-full gap-5 mb-2 relative"
				>
					<div
						class=" min-h-[149px] md:w-[48%] w-full {{
							getController('offerImageEn')?.value ? '' : 'border-dashed'
						}} {{
							getController('offerImageEn')?.value ? '' : 'border'
						}} rounded-[6px] border-[#D9DBE9]   flex justify-center items-center relative"
					>
						<p
							*ngIf="!getController('offerImageEn')?.value"
							class="text-gradient absolute top-4 ltr:left-[40%] rtl:right-[40%] text-[16px]"
						>
							*
						</p>
						<button (click)="uploadImage('en')">
							<label class="custom-file-upload cursor-pointer">
								<img
									class="m-auto rounded-[6px] {{
										getController('offerImageEn')?.value ? 'w-full' : ''
									}} "
									[src]="
										getController('offerImageEn')?.value
											? attachmentUrl + getController('offerImageEn')?.value
											: './assets/images/upload.svg'
									"
									alt=""
								/>

								<h1
									*ngIf="!getController('offerImageEn')?.value"
									class="text-dark-grey text-font-16 font-normal leading-[24px] m-0"
								>
									{{ 'ACTIONS.UPLOAD_IMG_EN' | translate }}
								</h1>
							</label>
						</button>
						<button
							class="absolute bottom-3 ltr:right-3 rtl:left-3"
							(click)="$event.stopPropagation(); uploadImage('en')"
						>
							<img
								*ngIf="getController('offerImageEn')?.value"
								class="bg-white rounded-full p-2 w-9"
								src="assets/images/camera.svg"
								alt=""
							/>
						</button>
					</div>
					<div
						class=" min-h-[149px] md:w-[48%] w-full {{
							getController('offerImageAr')?.value ? '' : 'border-dashed'
						}} {{
							getController('offerImageAr')?.value ? '' : 'border'
						}} rounded-[6px] border-[#D9DBE9]   flex justify-center items-center relative"
					>
						<p
							*ngIf="!getController('offerImageAr')?.value"
							class="text-gradient absolute top-4 ltr:left-[40%] rtl:right-[40%] text-[16px]"
						>
							*
						</p>
						<button (click)="uploadImage('ar')">
							<label class="custom-file-upload cursor-pointer">
								<img
									class="m-auto rounded-[6px] {{
										getController('offerImageAr')?.value ? 'w-full' : ''
									}} "
									[src]="
										getController('offerImageAr')?.value
											? attachmentUrl + getController('offerImageAr')?.value
											: './assets/images/upload.svg'
									"
									alt=""
								/>

								<h1
									*ngIf="!getController('offerImageAr')?.value"
									class="text-dark-grey text-font-16 font-normal leading-[24px] m-0"
								>
									{{ 'ACTIONS.UPLOAD_IMG_AR' | translate }}
								</h1>
							</label>
						</button>
						<button
							class="absolute bottom-3 ltr:right-3 rtl:left-3"
							(click)="$event.stopPropagation(); uploadImage('ar')"
						>
							<img
								*ngIf="getController('offerImageAr')?.value"
								class="bg-white rounded-full p-2 w-9"
								src="assets/images/camera.svg"
								alt=""
							/>
						</button>
					</div>
				</div>
				<!-- UPLOAD IMAGE  -->
				<!-- duration -->
				<div class="mt-24px">
					<p class="text-font-16 font-DIN-Medium text-dark-grey mb-[10px]">
						{{ 'PRODUCT_PROMO.DURATION' | translate }}
						<span class="text-salon">*</span>
					</p>
					<div
						class="flex flex-wrap md:justify-between w-full py-2 items-start"
					>
						<mat-form-field
							appearance="outline"
							class="md:w-[47%] w-[100%]"
							(click)="datepicker.open()"
						>
							<mat-label>{{
								'GENERAL_LABELS.START_DATE' | translate
							}}</mat-label>
							<input
								[dir]="translate.currentLang == 'en' ? 'ltr' : 'rtl'"
								matInput
								[readonly]="true"
								[min]="today"
								[matDatepicker]="datepicker"
								formControlName="startDate"
								class="text-[#4E4B66]"
								(dateChange)="startDateAfterEndDate(); getFilteredProducts()"
							/>
							<img
								*ngIf="getController('startDate')?.value"
								(click)="getController('startDate').reset()"
								class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
								src="./assets/images/close-square.svg"
								alt=""
							/>
							<mat-datepicker #datepicker> </mat-datepicker>
							<mat-error>
								<validation-message
									[controller]="getController('startDate')"
									controller_name="GENERAL_LABELS.START_DATE"
								>
								</validation-message>
							</mat-error>
						</mat-form-field>

						<p
							class="text-[#4E4B66] text-center md:mt-5 mx-auto w-[3%] max-mobile:w-[100%]"
						>
							{{ 'GENERAL.TO' | translate }}
						</p>
						<mat-form-field
							appearance="outline"
							class="md:w-[47%] w-[100%]"
							(click)="datepickerTo.open()"
						>
							<mat-label>{{ 'GENERAL_LABELS.END_DATE' | translate }}</mat-label>
							<input
								[readonly]="true"
								[dir]="translate.currentLang == 'en' ? 'ltr' : 'rtl'"
								matInput
								[min]="today"
								[matDatepicker]="datepickerTo"
								formControlName="endDate"
								class="text-[#4E4B66]"
								(dateChange)="startDateAfterEndDate(); getFilteredProducts()"
							/>
							<img
								*ngIf="getController('endDate')?.value"
								(click)="getController('endDate').reset()"
								class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
								src="./assets/images/close-square.svg"
								alt=""
							/>
							<mat-datepicker #datepickerTo> </mat-datepicker>
							<mat-error>
								<validation-message
									[controller]="getController('endDate')"
									controller_name="GENERAL_LABELS.END_DATE"
								>
								</validation-message>
							</mat-error>
						</mat-form-field>
						<!-- duration -->
					</div>

					<mat-error class="mb-[12px]">
						<div
							class="whitespace-nowrap"
							*ngIf="
								getController('endDate').value <
									getController('startDate').value &&
								getController('endDate').value
							"
						>
							{{ 'VALIDATION.END_DATE_ERROR' | translate }}
						</div>
					</mat-error>
				</div>
				<!-- max client usage -->
				<mat-form-field class="w-full relative" appearance="outline">
					<mat-label class="text-dark-grey">{{
						'PRODUCT_PROMO.MAX_CLIENT_USE' | translate
					}}</mat-label>
					<input
						(keyup)="clientUsageValidator()"
						(keypress)="skipLetterE($event)"
						required
						formControlName="clientUsageCount"
						class="text-font-16 text-[#4E4B66]"
						type="number"
						(wheel)="$event.preventDefault()"
						matInput
						placeholder="{{ 'PRODUCT_PROMO.MAX_CLIENT_USE' | translate }}"
					/>
					<img
						*ngIf="getController('clientUsageCount')?.value"
						(click)="getController('clientUsageCount')?.reset()"
						class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
						src="./assets/images/close-square.svg"
						alt=""
					/>
					<mat-error>
						<validation-message
							[controller]="getController('clientUsageCount')"
							controller_name="PRODUCT_PROMO.MAX_CLIENT_USE"
							pattern_Message="VALIDATION.NAME"
						>
						</validation-message>
					</mat-error>
					<mat-error
						*ngIf="
							this.getController('clientUsageCount')?.errors
								?.clientUsageExceedTotalmaxUsageCount
						"
					>
						{{ 'PRODUCT_PROMO.CLIENT_USAGE_EXCEED_TOTAL_USAGE' | translate }}
					</mat-error>
				</mat-form-field>

				<!-- MAX BOOKING USAGE -->

				<mat-form-field class="w-full relative mt-24px" appearance="outline">
					<mat-label class="text-dark-grey">{{
						'PRODUCT_PROMO.MAX_NO_USAGE' | translate
					}}</mat-label>
					<input
						(keyup)="clientUsageValidator()"
						(keypress)="skipLetterE($event)"
						required
						formControlName="maxUsageCount"
						class="text-font-16 text-[#4E4B66]"
						type="number"
						(wheel)="$event.preventDefault()"
						matInput
						maxlength="2"
						placeholder="{{ 'PRODUCT_PROMO.MAX_NO_USAGE' | translate }}"
					/>
					<img
						*ngIf="getController('maxUsageCount')?.value"
						(click)="getController('maxUsageCount')?.reset()"
						class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
						src="./assets/images/close-square.svg"
						alt=""
					/>
					<mat-error>
						<validation-message
							[controller]="getController('maxUsageCount')"
							controller_name="PRODUCT_PROMO.MAX_NO_USAGE"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		<h1 class="font-DIN-Medium text-font-16 text-dark-grey mb-[16px] mt-36px">
			{{ 'STORE.ADD_PRODUCT.CATEGORY_BRAND' | translate }}
		</h1>

		<div class="p-24px rounded-12px bg-off-white shadow mb-24px">
			<p class="text-font-16 text-dark-grey font-DIN-Medium">
				{{ 'GENERAL_LABELS.COUNTRY' | translate }}
				<span class="text-salon">*</span>
			</p>
			<mat-radio-group
				class="flex justify-between w-[65%]"
				(change)="
					promoCodeFilter.countryId = $event.value; getFilteredProducts()
				"
				formControlName="countryId"
				aria-label="Select an option"
			>
				<mat-radio-button
					class="ltr:mr-[24px] rtl:ml-[24px] text-font-14 text-dark-grey"
					[value]="224"
					>{{ 'COUNTRIES.EGYPT' | translate }}</mat-radio-button
				>
				<mat-radio-button [value]="103" class="text-font-14 text-dark-grey">{{
					'COUNTRIES.SAUDI_ARABIA' | translate
				}}</mat-radio-button>
			</mat-radio-group>

			<div>
				<p class="text-font-16 text-dark-grey font-DIN-Medium">
					{{ 'PRODUCT_PROMO.GENDER' | translate }}
				</p>

				<div class="flex justify-between w-[59%]">
					<mat-checkbox
						*ngFor="let gender of genders"
						(change)="targetAudienceChange($event)"
						[value]="gender.value"
						>{{
							'GENERAL_LABELS.' + gender.name.toUpperCase() | translate
						}}</mat-checkbox
					>
				</div>
			</div>

			<div class="flex justify-between">
				<!-- CATEGORY  -->
				<div class="w-[49%]">
					<h1 class="text-font-14 text-dark-grey font-Poppins-medium mb-12px">
						{{ 'STORE.ADD_PRODUCT.CATEGORY' | translate }}
					</h1>

					<mat-form-field
						appearance="outline"
						class="w-full custom-autocomplete"
					>
						<mat-select
							(selectionChange)="
								promoCodeFilter.categoryId = $event?.value;
								this.getController('subCategoryId').reset();
								this.getController('subSubcategoryId').reset();
								promoCodeFilter.subCategoryId = null;
								promoCodeFilter.subSubCategoryId = null;
								getFilteredProducts();
								categorySelectionChange()
							"
							panelClass=" my-0 mx-24px   "
							placeholder="{{ 'STORE.ADD_PRODUCT.CATEGORY' | translate }}"
							formControlName="categoryId"
						>
							<mat-select-trigger class="text-main-color-black">
								{{
									getController('categoryId')?.value
										? this.translate.currentLang == 'en'
											? categoryvalue?.name?.en
											: categoryvalue?.name?.ar
										: ''
								}}
							</mat-select-trigger>
							<div class="select-container">
								<mat-form-field
									class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
									appearance="outline"
								>
									<div>
										<img
											class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px m-[6px]"
											src="./assets/images/search-normal.svg"
											alt=""
										/>
									</div>
									<input
										matInput
										type="text"
										(keydown)="$event.stopPropagation()"
										[formControl]="categoryKeyWord"
										placeholder="{{ 'GENERAL_LABELS.SEARCH' | translate }}"
										class="absolute w-[92%] ltr:left-10 rtl:right-10"
									/>
									<img
										*ngIf="categoryKeyWord.value"
										(click)="categoryKeyWord.setValue('')"
										class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
										src="./assets/images/close-square.svg"
										alt=""
									/>
								</mat-form-field>

								<div class="max-h-[250px]">
									<ng-container *ngFor="let category of categoryList">
										<mat-option
											(click)="
												getSubCategoryList('', category.id);
												categoryvalue = category
											"
											[value]="category?.id"
										>
											{{
												translate.currentLang == 'en'
													? category?.name?.en
													: category?.name?.ar
											}}
										</mat-option>
									</ng-container>
									<mat-option
										disabled
										class="only-check"
										*ngIf="!categoryList?.length"
									>
										{{ 'STORE.ADD_PRODUCT.NO_CATEGORY_FOUND' | translate }}
									</mat-option>
								</div>
							</div>
						</mat-select>
					</mat-form-field>
				</div>
				<!-- CATEGORY  -->
				<!-- SUB CATEGORY -->

				<div class="w-[49%]">
					<h1 class="text-font-14 text-dark-grey font-Poppins-medium mb-12px">
						{{ 'STORE.ADD_PRODUCT.SUB_CATEGORY' | translate }}
					</h1>
					<mat-form-field
						appearance="outline"
						class="w-full custom-autocomplete"
					>
						<mat-select
							(selectionChange)="
								promoCodeFilter.subCategoryId = $event?.value;
								getFilteredProducts();
								categorySelectionChange()
							"
							panelClass=" my-0 mx-24px  "
							placeholder="{{ 'STORE.ADD_PRODUCT.SUB_CATEGORY' | translate }}"
							formControlName="subCategoryId"
						>
							<mat-select-trigger class="text-main-color-black">
								{{
									getController('subCategoryId')?.value
										? this.translate.currentLang == 'en'
											? subCategory?.name?.en
											: subCategory?.name?.ar
										: ''
								}}
							</mat-select-trigger>
							<div class="select-container">
								<mat-form-field
									class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
									appearance="outline"
								>
									<div>
										<img
											class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px m-[6px]"
											src="./assets/images/search-normal.svg"
											alt=""
										/>
									</div>
									<input
										matInput
										type="text"
										(keydown)="$event.stopPropagation()"
										[formControl]="subCategoryKeyWord"
										placeholder="{{ 'GENERAL_LABELS.SEARCH' | translate }}"
										class="absolute w-[92%] ltr:left-10 rtl:right-10"
									/>
									<img
										*ngIf="subCategoryKeyWord.value"
										(click)="subCategoryKeyWord.setValue('')"
										class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
										src="./assets/images/close-square.svg"
										alt=""
									/>
								</mat-form-field>

								<div class="max-h-[250px]">
									<ng-container *ngFor="let category of subCategoryList">
										<mat-option
											(click)="
												getSubSubCategoryList(
													'',
													getController('subCategoryId').value
												);
												subCategory = category
											"
											[value]="category?.id"
										>
											{{
												translate.currentLang == 'en'
													? category?.name?.en
													: category?.name?.ar
											}}
										</mat-option>
									</ng-container>
									<mat-option
										disabled
										class="only-check"
										*ngIf="!subCategoryList?.length"
									>
										{{ 'STORE.ADD_PRODUCT.NO_SUB_CATEGORY_FOUND' | translate }}
									</mat-option>
								</div>
							</div>
						</mat-select>
					</mat-form-field>
				</div>

				<!-- SUB CATEGORY -->
			</div>
			<!-- Category & Brand FORM GROUP  -->
			<!-- SUB SUB CATEGORY  -->
			<div class="flex justify-between">
				<div class="w-[49%]">
					<h1 class="text-font-14 text-dark-grey font-Poppins-medium mb-12px">
						{{ 'STORE.ADD_PRODUCT.SUB_SUB_CATEGORY' | translate }}
					</h1>

					<mat-form-field
						appearance="outline"
						class="w-full custom-autocomplete"
					>
						<mat-select
							(selectionChange)="
								promoCodeFilter.subSubCategoryId = $event?.value;
								getFilteredProducts();
								categorySelectionChange()
							"
							panelClass=" my-0 mx-24px   "
							placeholder="{{
								'STORE.ADD_PRODUCT.SUB_SUB_CATEGORY' | translate
							}}"
							formControlName="subSubcategoryId"
						>
							<mat-select-trigger class="text-main-color-black">
								{{
									getController('subSubcategoryId')?.value
										? this.translate.currentLang == 'en'
											? subSubCategory?.name?.en
											: subSubCategory?.name?.ar
										: ''
								}}
							</mat-select-trigger>
							<div class="select-container">
								<mat-form-field
									class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
									appearance="outline"
								>
									<div>
										<img
											class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px m-[6px]"
											src="./assets/images/search-normal.svg"
											alt=""
										/>
									</div>
									<input
										matInput
										type="text"
										(keydown)="$event.stopPropagation()"
										[formControl]="subSubCategoryKeyWord"
										placeholder="{{ 'GENERAL_LABELS.SEARCH' | translate }}"
										class="absolute w-[92%] ltr:left-10 rtl:right-10"
									/>
									<img
										*ngIf="subSubCategoryKeyWord.value"
										(click)="subSubCategoryKeyWord.setValue('')"
										class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
										src="./assets/images/close-square.svg"
										alt=""
									/>
								</mat-form-field>

								<div class="max-h-[250px]">
									<mat-option
										(click)="subSubCategory = category"
										*ngFor="let category of subSubCategoryList"
										[value]="category.id"
									>
										{{
											translate.currentLang == 'en'
												? category?.name?.en
												: category?.name?.ar
										}}
									</mat-option>
									<mat-option
										disabled
										class="only-check"
										*ngIf="!subSubCategoryList?.length"
									>
										{{
											'STORE.ADD_PRODUCT.NO_SUB_SUB_CATEGORY_FOUND' | translate
										}}
									</mat-option>
								</div>
							</div>
						</mat-select>
					</mat-form-field>
				</div>
				<!-- SUB SUB CATEGORY  -->
				<!-- BRANDS  -->
				<div class="w-[49%]">
					<h1 class="text-font-14 text-dark-grey font-Poppins-medium mb-12px">
						{{ 'STORE.ADD_PRODUCT.BRAND' | translate }}
					</h1>

					<mat-form-field
						appearance="outline"
						class="w-full custom-autocomplete"
					>
						<mat-select
							(selectionChange)="
								promoCodeFilter.brandId = $event?.value;
								getFilteredProducts();
								categorySelectionChange()
							"
							panelClass=" my-0 mx-24px  "
							placeholder="	{{ 'STORE.ADD_PRODUCT.BRAND' | translate }}"
							formControlName="brandId"
						>
							<mat-select-trigger class="text-main-color-black">
								{{
									getController('brandId')?.value
										? this.translate.currentLang == 'en'
											? selectedBrand?.name?.en
											: selectedBrand?.name?.ar
										: ''
								}}
							</mat-select-trigger>
							<div class="select-container">
								<mat-form-field
									class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
									appearance="outline"
								>
									<div>
										<img
											class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px m-[6px]"
											src="./assets/images/search-normal.svg"
											alt=""
										/>
									</div>
									<input
										matInput
										type="text"
										(keydown)="$event.stopPropagation()"
										[formControl]="brandKeyWord"
										placeholder="{{ 'GENERAL_LABELS.SEARCH' | translate }}"
										class="absolute w-[92%] ltr:left-10 rtl:right-10"
									/>
									<img
										*ngIf="brandKeyWord.value"
										(click)="brandKeyWord.setValue('')"
										class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
										src="./assets/images/close-square.svg"
										alt=""
									/>
								</mat-form-field>

								<div class="max-h-[250px]">
									<ng-container *ngFor="let brand of brandList">
										<mat-option
											[value]="brand.id"
											(click)="selectedBrand = brand"
										>
											{{
												translate.currentLang == 'en'
													? brand?.name?.en
													: brand?.name?.ar
											}}
										</mat-option>
									</ng-container>
									<mat-option
										disabled
										class="only-check"
										*ngIf="!brandList?.length"
									>
										{{ 'STORE.ADD_PRODUCT.NO_BRANDS_FOUND' | translate }}
									</mat-option>
								</div>
							</div>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
			<h1 class="font-DIN-Medium text-font-16 text-dark-grey mb-[16px]">
				{{ 'PRODUCT_PROMO.PRODUCT_INFO' | translate }}
			</h1>
			<div class="w-full">
				<mat-form-field appearance="outline" class="w-full custom-autocomplete">
					<mat-select
						(openedChange)="checkProductsStartEndDate()"
						#select
						(selectionChange)="selectionShowName(); getSelectedProductNames()"
						multiple="true"
						panelClass="my-0 mx-24px"
						placeholder="{{ 'PRODUCT_PROMO.PRODUCTS' | translate }}"
						formControlName="productVariantIds"
					>
						<mat-select-trigger class="text-main-color-black">
							<ng-container *ngIf="selectedProductNames?.length">
								<ng-container
									*ngFor="let product of selectedProductNames; let i = index"
								>
									<span *ngIf="translate.currentLang == 'en' && i < 3"
										>{{
											product?.name?.en.length > 13
												? (product?.name?.en | slice : 0 : 15)
												: product?.name?.en
										}}

										{{ product?.name?.en.length > 13 ? '...' : null }}
										<span
											*ngIf="
												i < selectedProductNames.length - 1 &&
												selectedProductNames.length < 4
											"
											>,</span
										>
									</span>
								</ng-container>
								<span
									*ngIf="
										selectedProductNames?.length &&
										selectedProductNames.length - 3 !== 0
											? selectedProductNames.length >= 3
											: null
									"
								>
									&{{
										selectedProductNames?.length
											? selectedProductNames.length - 3
											: null
									}}
									{{ 'GENERAL.OTHER' | translate }}
								</span>
							</ng-container>
						</mat-select-trigger>
						<div>
							<mat-form-field
								*ngIf="!hideProductSearch"
								class="w-[97%] ltr:ms-[12px] rtl:me-[12px] mt-2 bg-light-grey text-main-color-black relative overflow-hidden"
								appearance="outline"
							>
								<div>
									<img
										class="absolute ltr:left-0 rtl:right-0 inline-block top-[9px] pr-12px m-[6px]"
										src="./assets/images/search-normal.svg"
										alt=""
									/>
								</div>
								<input
									matInput
									type="text"
									(keydown)="$event.stopPropagation()"
									[formControl]="productKeyword"
									placeholder="{{ 'GENERAL_LABELS.SEARCH' | translate }}"
									class="absolute w-[92%] ltr:left-10 rtl:right-10"
								/>
								<img
									*ngIf="productKeyword.value"
									(click)="productKeyword.setValue('')"
									class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
									src="./assets/images/close-square.svg"
									alt=""
								/>
							</mat-form-field>

							<div class="max-h-[250px]">
								<mat-option
									*ngIf="promoCodeProductList?.length"
									#allSelected
									[value]="0"
									(click)="toggleAllSelection()"
								>
									{{ 'PRODUCT_PROMO.SELECT_ALL' | translate }}
								</mat-option>
								<ng-container *ngFor="let product of promoCodeProductList">
									<mat-option
										[value]="product?.variantId"
										(click)="checkAllSelected()"
									>
										{{
											translate.currentLang == 'en'
												? product?.name?.en
												: product?.name?.ar
										}}
									</mat-option>
								</ng-container>

								<div
									*ngIf="!promoCodeProductList?.length"
									class="customMatOption"
								>
									<mat-option [disabled]="true">
										<p
											*ngIf="
												!promoCodeProductList?.length &&
												getController('startDate').value &&
												getController('endDate').value
											"
											class="text-dark-grey"
										>
											{{ 'STORE.ADD_PRODUCT.NO_PRODUCT_FOUND' | translate }}
										</p>
										<p
											*ngIf="
												!promoCodeProductList?.length &&
												(!getController('startDate').value ||
													!getController('endDate').value)
											"
											class="text-dark-grey"
										>
											{{
												'PRODUCT_PROMO.SELECT_DATES_FOR_PRODUCT_LIST'
													| translate
											}}
										</p>
									</mat-option>
								</div>
							</div>
						</div>
					</mat-select>
				</mat-form-field>
				<p *ngIf="labelOverlapError" class="text-red-error">
					{{ 'PRODUCT_PROMO.ERROR_MESSAGE' | translate }}
				</p>
				<div class="flex flex-wrap overflow-y-scroll max-h-[250px]">
					<div
						*ngFor="let product of selectedProductNames"
						class="flex justify-center p-3 rounded-[50px] bg-gradient text-off-white mb-3 mx-1"
					>
						<p class="mb-0 whitespace-nowrap">
							{{
								translate.currentLang == 'en'
									? product?.name?.en
									: product?.name?.ar
							}}
						</p>
						<img
							(click)="removeProduct(product)"
							class="mx-1 mt-0.5 h-[16px] w-[16px] cursor-pointer"
							alt="icon"
							src="assets/images/close-circle-white.png"
						/>
					</div>
				</div>
				<mat-checkbox
					(change)="checkOverlapLabel()"
					class="my-12px"
					formControlName="showLabel"
					>{{ 'PRODUCT_PROMO.SHOW_LABEL' | translate }}</mat-checkbox
				>
			</div>
			<!-- SAME PRODUCT   -->
			<mat-form-field class="w-full relative" appearance="outline">
				<mat-label class="text-dark-grey">{{
					'PRODUCT_PROMO.SAME_PRODUCT' | translate
				}}</mat-label>
				<input
					(keypress)="skipLetterE($event)"
					formControlName="numberOfSameProduct"
					class="text-font-16 text-[#4E4B66] w-[95%]"
					type="number"
					(wheel)="$event.preventDefault()"
					matInput
					maxlength="2"
					placeholder="{{ 'PRODUCT_PROMO.SAME_PRODUCT' | translate }}"
				/>
				<img
					*ngIf="getController('numberOfSameProduct')?.value"
					(click)="getController('numberOfSameProduct')?.reset()"
					class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
					src="./assets/images/close-square.svg"
					alt=""
				/>
				<mat-error>
					<validation-message
						[controller]="getController('numberOfSameProduct')"
						controller_name="PRODUCT_PROMO.SAME_PRODUCT"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
		</div>

		<h1 class="font-DIN-Medium text-font-16 text-dark-grey mb-[16px]">
			{{ 'PRODUCT_PROMO.OFFER_DETAILS' | translate }}
		</h1>
		<div class="p-24px rounded-12px bg-off-white shadow mb-24px">
			<!-- OFFER TYPE  -->
			<div class="mt-16px">
				<p class="text-font-16 text-dark-grey font-DIN-Medium">
					{{ 'PRODUCT_PROMO.OFFER_TYPE' | translate }}
					<span class="text-salon">*</span>
				</p>
				<mat-radio-group
					(change)="changePromoCodeType($event)"
					formControlName="promoCodeType"
				>
					<ng-container *ngFor="let type of promoTypes">
						<mat-radio-button
							[value]="type"
							class="ltr:mr-[24px] rtl:ml-[24px] text-font-14 text-dark-grey"
							>{{ 'PRODUCT_PROMO.' + type?.name | translate }}</mat-radio-button
						>
					</ng-container>
				</mat-radio-group>
				<div *ngIf="getController('promoCodeType')?.value?.value == 1">
					<mat-form-field class="w-full relative" appearance="outline">
						<mat-label class="text-dark-grey">{{
							'PRODUCT_PROMO.OFFER_AMOUNT' | translate
						}}</mat-label>
						<input
							(keyup)="promocodeAmountValidator()"
							(keypress)="skipLetterE($event)"
							(wheel)="$event.preventDefault()"
							required="true"
							formControlName="promocodeAmount"
							type="number"
							class="text-font-16 text-[#4E4B66] w-[95%]"
							placeholder="{{ 'PRODUCT_PROMO.OFFER_AMOUNT' | translate }}"
							matInput
							maxlength="20"
						/>
						<span class="text-dark-grey mx-2" matSuffix>
							{{
								getController('countryId')?.value == 103
									? ('CURRENCY.SAR' | translate)
									: ('CURRENCY.EGP' | translate)
							}}
						</span>
						<img
							*ngIf="getController('promocodeAmount')?.value"
							(click)="getController('promocodeAmount')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('promocodeAmount')"
								controller_name="PRODUCT_PROMO.OFFER_AMOUNT"
							>
							</validation-message>
						</mat-error>
						<mat-error
							*ngIf="
								this.getController('promocodeAmount')?.errors
									?.amountExceedMinimum
							"
						>
							{{ 'VALIDATION.VALUE_EXCEED_DISCOUNT' | translate }}
						</mat-error>
					</mat-form-field>

					<mat-form-field class="w-full relative" appearance="outline">
						<mat-label class="text-dark-grey">{{
							'PRODUCT_PROMO.CHECKOUT' | translate
						}}</mat-label>
						<input
							(keyup)="promocodeAmountValidator()"
							(keypress)="skipLetterE($event)"
							(wheel)="$event.preventDefault()"
							formControlName="fixedDiscountMinimum"
							type="number"
							class="text-font-16 text-[#4E4B66] w-[95%]"
							placeholder="{{ 'PRODUCT_PROMO.CHECKOUT' | translate }}"
							matInput
							maxlength="20"
						/>
						<span class="text-dark-grey mx-2" matSuffix>
							{{
								getController('countryId')?.value == 103
									? ('CURRENCY.SAR' | translate)
									: ('CURRENCY.EGP' | translate)
							}}
						</span>
						<img
							*ngIf="getController('fixedDiscountMinimum')?.value"
							(click)="getController('fixedDiscountMinimum')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('fixedDiscountMinimum')"
								controller_name="PRODUCT_PROMO.CHECKOUT"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
				</div>

				<div *ngIf="getController('promoCodeType')?.value?.value == 2">
					<mat-form-field class="w-full relative" appearance="outline">
						<mat-label class="text-dark-grey">{{
							'PRODUCT_PROMO.PERCENTAGE' | translate
						}}</mat-label>
						<input
							required="true"
							(keyup)="promocodePercentageValidator()"
							(keypress)="skipLetterE($event)"
							(wheel)="$event.preventDefault()"
							formControlName="promocodeAmount"
							type="number"
							class="text-font-16 text-[#4E4B66] w-[95%]"
							placeholder="{{ 'PRODUCT_PROMO.OFFER_AMOUNT' | translate }}"
							matInput
							maxlength="20"
						/>
						<span class="text-dark-grey mx-2" matSuffix>
							{{ '%' }}
						</span>
						<img
							*ngIf="getController('promocodeAmount')?.value"
							(click)="getController('promocodeAmount')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('promocodeAmount')"
								controller_name="PRODUCT_PROMO.PERCENTAGE"
							>
							</validation-message>
						</mat-error>
						<mat-error
							*ngIf="
								this.getController('promocodeAmount')?.errors
									?.percentageCantExceedHundred
							"
						>
							{{ 'VALIDATION.DISCOUNT_PERCENTAGE_MAX' | translate }}
						</mat-error>
					</mat-form-field>

					<mat-form-field class="w-full relative" appearance="outline">
						<mat-label class="text-dark-grey">{{
							'PRODUCT_PROMO.UPTO' | translate
						}}</mat-label>
						<input
							(keypress)="skipLetterE($event)"
							(wheel)="$event.preventDefault()"
							required="true"
							formControlName="percentageUpto"
							type="number"
							class="text-font-16 text-[#4E4B66] w-[95%]"
							placeholder="{{ 'PRODUCT_PROMO.UPTO' | translate }}"
							matInput
							maxlength="20"
						/>
						<span class="text-dark-grey mx-2" matSuffix>
							{{
								getController('countryId')?.value == 103
									? ('CURRENCY.SAR' | translate)
									: ('CURRENCY.EGP' | translate)
							}}
						</span>
						<img
							*ngIf="getController('percentageUpto')?.value"
							(click)="getController('percentageUpto')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('percentageUpto')"
								controller_name="PRODUCT_PROMO.UPTO"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
				</div>

				<div *ngIf="getController('promoCodeType')?.value?.value == 3">
					<mat-form-field class="w-full relative" appearance="outline">
						<mat-label class="text-dark-grey">{{
							'PRODUCT_PROMO.BUY_NUM' | translate
						}}</mat-label>
						<input
							required="true"
							(keypress)="skipLetterE($event)"
							(wheel)="$event.preventDefault()"
							formControlName="offerBuyCount"
							type="number"
							class="text-font-16 text-[#4E4B66]"
							placeholder="{{ 'PRODUCT_PROMO.BUY_NUM' | translate }}"
							matInput
							maxlength="20"
						/>
						<img
							*ngIf="getController('offerBuyCount')?.value"
							(click)="getController('offerBuyCount')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('offerBuyCount')"
								controller_name="PRODUCT_PROMO.BUY_NUM"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>

					<mat-form-field class="w-full relative" appearance="outline">
						<mat-label class="text-dark-grey">{{
							'PRODUCT_PROMO.GET_NUM' | translate
						}}</mat-label>
						<input
							required="true"
							formControlName="offerGetCount"
							type="number"
							(keypress)="skipLetterE($event)"
							(wheel)="$event.preventDefault()"
							class="text-font-16 text-[#4E4B66]"
							placeholder="{{ 'PRODUCT_PROMO.GET_NUM' | translate }}"
							matInput
							maxlength="20"
						/>
						<img
							*ngIf="getController('offerGetCount')?.value"
							(click)="getController('offerGetCount')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('offerGetCount')"
								controller_name="PRODUCT_PROMO.GET_NUM"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<!-- OFFER TYPE  -->
		</div>
	</div>

	<button
		[disabled]="productPromoCodeForm?.invalid || labelOverlapError"
		(click)="save()"
		mat-button
		class="bg-gradient text-font-14 text-off-white rounded-[5px] w-full py-8px"
	>
		{{ 'ACTIONS.SAVE' | translate }}
	</button>
	<button
		(click)="cancel()"
		class="bg-transparent text-font-14 border-solid border-[1px] secondry-color-Gray rounded-[5px] w-full py-8px my-[8px]"
	>
		{{ 'ACTIONS.CANCEL' | translate }}
	</button>
</div>
